/** Backend limits on the pin list. Enforced here so a 400 is prevented, not reported. */
export const JOTFORM_MAX_PINNED_FORMS = 25;
export const JOTFORM_MAX_FORM_ID_LENGTH = 64;

export type NormalizedFormIds = {
  formIds: string[];
  rejected: "tooMany" | "tooLong" | null;
};

/**
 * Mirror the backend's normalization — trim, drop blanks, collapse duplicates
 * keeping first-seen order — then report a limit breach instead of sending a
 * request that would 400.
 *
 * Form id shape is deliberately not validated: the format is JotForm's to
 * change, and a wrong id already fails closed at submission time.
 */
export function normalizeFormIds(raw: string[]): NormalizedFormIds {
  const formIds: string[] = [];
  for (const entry of raw) {
    const trimmed = entry.trim();
    if (!trimmed || formIds.includes(trimmed)) continue;
    formIds.push(trimmed);
  }

  if (formIds.some((id) => id.length > JOTFORM_MAX_FORM_ID_LENGTH)) {
    return { formIds, rejected: "tooLong" };
  }
  if (formIds.length > JOTFORM_MAX_PINNED_FORMS) {
    return { formIds, rejected: "tooMany" };
  }
  return { formIds, rejected: null };
}
